<!--模板-->
<template>
  <div id="accompanyBg" class="zwcWidth">
    <!-- 大背景 -->
    <div class="zwcWidth bg">
      <div class="flex">
        <h1  style="font-size: 85px;text-shadow:5px 2px 6px #000;">陪伴</h1>
        <h3 style="text-shadow:5px 2px 6px #000;">在孤单的时候，你总需要一个人帮助你找到欢笑~</h3>
        <div class="shade">
          <div style="display: table-cell;vertical-align: middle;text-align: center;">
            <div style="padding: 20px ">
              <el-autocomplete
                v-model="searchTextData"
                style="width: 100%;"
                :clearable="true"
                :debounce="300"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入您心心向往的美丽城市..."
                @select="handleSelect"
              ></el-autocomplete>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选项卡 -->
<!--    <div class="seconedWidth flex-container" style="margin-top: 30px">-->
<!--      <div class="flex-item card_list"  @click="active(0)">-->
<!--        <img src="../../../static/images/placeholder/world-city-img1-235x235.jpg" alt="">-->
<!--        <p>休闲娱乐</p>-->
<!--      </div>-->
<!--      <div class="flex-item card_list"  @click="active(1)">-->
<!--        <img src="../../../static/images/placeholder/world-city-img1-235x235.jpg" alt="">-->
<!--        <p>休闲娱乐</p>-->
<!--      </div>-->
<!--      <div class="flex-item"  @click="active(2)">-->
<!--        <img src="../../../static/images/placeholder/world-city-img1-235x235.jpg" alt="">-->
<!--        <p>休闲娱乐</p>-->
<!--      </div>-->
<!--      <div class="flex-item"  @click="active(3)">-->
<!--        <img src="../../../static/images/placeholder/world-city-img1-235x235.jpg" alt="">-->
<!--        <p>休闲娱乐</p>-->
<!--      </div>-->
<!--      <div class="flex-item">-->
<!--        <img src="../../../static/images/placeholder/world-city-img1-235x235.jpg" alt="">-->
<!--        <p>休闲娱乐</p>-->
<!--      </div>-->
<!--      &lt;!&ndash;<div class="left_arrow"></div>&ndash;&gt;-->
<!--      &lt;!&ndash;<div class="rigth_arrow"></div>&ndash;&gt;-->
<!--    </div>-->

    <!--筛选-->
<!--    <div class="classify_bg">-->
<!--      <table>-->
<!--        <tr>-->
<!--          <td>选择类型</td>-->
<!--          <td>-->
<!--            这里是类型-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td>性别</td>-->
<!--          <td>-->
<!--            <span>男</span>-->
<!--            <span>女</span>-->
<!--          </td>-->
<!--        </tr>-->
<!--      </table>-->
<!--    </div>-->

    <!-- 分类 -->
    <div class="seconedWidth classify" >
      <h2>热门技能服务</h2>
      <div class="border_b">
        <span></span>
        <p></p>
      </div>
      <p>热门推荐的陪陪技能服务者</p>
    </div>

    <!-- 卡片 -->
    <div class="seconedWidth card"  >
      <el-row  >
        <el-col class="card_list mar10" :span="8" v-for="(item,index) in servesList.data" :key="index" :offset="index > 0 ? 4 : 0" @click="serviceBtn(item)" >
          <el-card :body-style="{padding: '0px'}" style="position: relative">
            <img   :src="item.serveCoverImg.split(',')[0]" class="card_image" @click="serviceBtn(item)">
            <div class="name_img" @click="serviceBtn(item)">
              <img :src="item.user.headImg" alt="">
              <span>{{item.user.name}}</span>
            </div>
            <div style="padding: 20px 10px;" @click="serviceBtn(item)">
              <span class="name_title">{{item.title}}</span>
              <div class=" clearfix">
                <time class="time">[{{item.pushTypeStr}}]
                  <!--<span></span>四点九分-->
                </time>
                <!-- <time type="text" class="button">￥{{item.pushPrice}}/{{item.servePriceName}}</time> -->
                <time type="text" class="button">推荐</time>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <p style="text-align: right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="pageChange"
          :current-page="page"
          :page-sizes="[30, 50, 80, 100]"
          :page-size="30"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData">
        </el-pagination>
      </p>
    </div>
  </div>
</template>


<!--JS-->
<script>
  import {selectServes,selectRegionByName} from '@/api/apis'

  export default {
    data() {
      return {
        offsetCount: 0,
        input5:'',
        servesList:'',
        searchTextData:'',
        regionList:'',
        totalData:0,
        page:1,
        pageSize:30
      }
    },
    methods:{
      handleSizeChange(val) {
        this.pageSize = val
        // 获取服务服务列表
        this.getList()
        console.log(`每页 ${val} 条`);
      },
      pageChange(val){
        this.page = val
        // 获取服务服务列表
        this.getList()
        console.log(this.page,val,"翻页")
      },
      querySearchAsync(queryString, cb) {
        let vm = this
        selectRegionByName({
          name:vm.searchTextData,
        }).then((res)=>{
          if(res.code == '000000'){
            let dataList = []
            for(let item of res.data){
              let list = { "value": item.areaname, "id": item.parentid }
              dataList.push(list)
            }
            vm.regionList = dataList
            cb(dataList);

          } else {
            // vm.$message.warning(res.repMsg)
          }
        })
        // clearTimeout(this.timeout);
        // vm.timeout = setTimeout(() => {
        //
        // }, 1 * Math.random());
      },
      handleSelect(item) {
        let vm = this
        console.log(item,"3");
        console.log(this.searchTextData)
        vm.$router.push('/city?cityText=' + item.value + '&cityCode=' + item.id)
      },
      serviceBtn(item){
        console.log("22222222222222")
        this.$router.push('/homePage?nameCode=' + item.userCode + '&nameService=' + item.code)
      },
      // 获取列表
      getList(){
        let vm = this
        // 获取服务服务列表
        selectServes({
          nowPage:vm.page,
          nowPageDataNum:vm.pageSize,
          map:{status:0}
        }).then((res)=>{
          if(res.code == '000000'){
            vm.totalData = res.data.totalDataNum
            vm.servesList = res.data
          } else {
            vm.$message.warning(res.msg)
          }
        })
      }
    },
    mounted(){
      let vm = this
      // 获取服务服务列表
      vm.getList()
    }
  }
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../scss/commonH5.scss';
  .mar10{
    margin-bottom: 20px;
  }
  .name_title{
    width:220px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display: inline-block;
  }
  .infinite-list{
    height: 300px;
    background: #ddd;
  }
  .card_list{
    cursor: pointer;
    transition:all 0.3s;-webkit-transition:all 0.3s;-moz-transition:all 0.3s;
  }
  .card_list:hover{
    opacity:0.8;filter:alpha(opacity=80);
    transform:scale(1.03);-webkit-transform:scale(1.03);-moz-transform:scale(1.03);
  }
  .card_list img {
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    border-radius: 5px;
  }

  .card_list:hover .card_image {
    filter: alpha(opacity=80);
    transform: scale(1.1);
    border-radius: 5px;
  }
  .card_image {
    width: 100%;
    display: block;
    height: 230px;
  }
  .name_img span{
    color: #fff;
    font-size: 14px;
    padding-left: 5px;
  }
  .name_img{
    position: absolute;
    top: 190px;
    left: 28px;
  }
  .name_img img{
    border-radius: 50%;
    width: 50px;
    height: 50px;
  }
  .classify_bg table{
    border: 1px solid #ddd;
    font-size: 15px;
    width: 1000px;
  }
  .classify_bg tr{
    height: 50px;
    width: 100%;
    border: 1px solid #ddd;
  }
  .classify_bg td:first-child{
    width: 15%;
    background:#f5f5f5 ;
    text-align: right;
    padding: 0 20px;
  }
  .classify_bg td:last-child{
    width: 85%;
    padding: 0 20px;
  }
  .classify_bg{
    width: 1000px;
    margin: 30px auto 0;
    height: auto;
  }
  /*外层样式*/
  .zwcWidth{
    width:100%;
  }
  /*内层居中样式*/
  .seconedWidth{
    width:1000px;
    margin:0 auto;
  }

  // header头部
  #header {
    height: 80px;
    // padding: 30px 0;
  }
  #header>div:first-child {
    padding-top: 15px;
  }
  #header img {
    display: block;
    width: 120px;
  }
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .el-menu.el-menu--horizontal li {
    padding: 0;
    margin: 0 20px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
  .el-menu.el-menu--horizontal li:last-child {
    margin-right: 0;
  }
  /*面包屑导航*/
  .el-breadcrumb {
    font-size: 14px;
    line-height: 1;
    text-align: right;
  }
  .el-breadcrumb span {
    float: inherit;
  }
  .r_nav {
    padding-top: 15px;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #FF6600;
    color: #FF6600;
    border-bottom-color: #FF6600 !important;
  }
  .el-breadcrumb[data-v-297fe81f] {
    font-size: 12px;
    line-height: 1;
    text-align: right;
  }
  /*导航下大背景*/
  .bg {
    background: url(../../../static/images/title/accompany.jpg) no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 500px;
    display: flex;
  }
  .bg .flex {
    align-self: center;
    margin: auto;
  }
  .bg .flex h1 {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
  }
  .bg .flex h3 {
    color: #ffffff;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
  }
  .bg .flex .shade {
    width: 700px;
    height: 100px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    display: table;
    margin-top: 15px;
  }
  .el-select .el-input {
    width: 80px;
  }
  .el-input-group {
    width: 93%;
  }
  .el-input-group__append {
    background-color: $fontColor !important;
    color: #ffffff;
    border: 0;
  }
  /*玩行分类*/
  .classify{
    padding: 60px 0 0 0 ;
  }
  .classify h2{
    color: $fontColor;
    font-size: 25px;
    font-weight: 600;
    text-align: center;
  }
  .classify .border_b {
    margin: 10px 0;
  }
  .classify .border_b p{
    width: 250px;
    height: 1px;
    margin: auto;
    background-color: #E0DEDE;
  }
  .classify .border_b span {
    width: 25px;
    height: 2px;
    display: block;
    margin: auto;
    background-color: #2F2F2F;
  }
  .classify>p {
    color: #8D8A8A;
    text-align: center;
    font-size: 15px;
  }
  /*选项卡*/
  .flex-container {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    position: relative;
    // width: 400px;
    // height: 250px;
    // background-color: lightgrey;
  }
  .flex-container .left_arrow {
    background: url(../../../static/images/guide/jian.png) no-repeat;
    width: 35px;
    height: 50px;
    position: absolute;
    top: 15px;
    left: -80px;
    cursor:pointer;
  }
  .flex-container .rigth_arrow {
    background: url(../../../static/images/guide/jian.png) no-repeat;
    width: 35px;
    height: 50px;
    position: absolute;
    top: 15px;
    right: -80px;
    cursor:pointer;
    transform:rotate(180deg);
    -o-transform:rotate(180deg); /* Opera */
    -ms-transform:rotate(180deg); /* Internet Explorer */
    -moz-transform:rotate(180deg); /* Firefox */
    -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
  }

  .flex-item img {
    // background-color: cornflowerblue;
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  .flex-item p {
    color: $fontColor;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding-top: 8px;
  }
  /*卡片*/
  .time {
    font-size: 13px;
    color: #9B9B9B;
  }
  .time>span {
    width: 2px;
    height: 14px;
    background-color: #9B9B9B;
    display: inline-block;
    margin: 0 3px;
    vertical-align: -2px;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
    color: $fontColor;
    font-weight: 600;
  }

  .image {
    width: 100%;
    display: block;
  }
  .el-card{
    font-size: 15px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
  .card {
    margin: 60px auto 80px;
  }
  .card .el-row:first-child {
    margin-bottom: 20px;
  }
  .el-col-8 {
    width: 25%;
    padding:  10px;
  }
  .el-col-offset-4 {
    margin-left: 0px!important;
  }

  /*底部*/
  .bottom_bg {
    background-color: #020202;
    // margin-bottom: 300px;
  }
  .topL ul li {
    float: left;
    padding-right: 10px;
  }
  .topL ul li a {
    border-left: 2px solid #ffffff;
    padding-left: 10px;
    color: #ffffff;
    font-size: 14px;
  }
  .topL h5:first-child {
    margin-top: 15px !important;
  }
  .catListTitle {
    font-weight: bold;
    line-height: 17px;
    font-size: 12px;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: left;
    color: #A4A4A4;
    padding: 0px 0px 0px 32px;
  }

  .topR img {
    width: 85px;
    height: 85px;
  }
  .topR p {
    text-align: center;
    font-size: 12px;
    color: #ffffff;
  }

  /* 下-底部 */
  .b_base {
    margin: auto;
    display: table;
  }
  .b_base ul li {
    float: left;
  }
  .b_base ul li a {
    border-right: 2px solid #ffffff;
    padding-right: 5px;
    padding-left: 5px;
    color: #ffffff;
    font-size: 12px;
  }
  .record {
    text-align: center;
    color: #ffffff;
    font-size: 12px;
    padding-bottom: 10px;
  }
</style>
<style lang="scss">
  #accompanyBg .zwcWidth{
    .el-input__inner{
      font-size: 21px!important;
      height: 65px!important;
      line-height: 65px!important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/list/accompany.vue